import { render } from "./lucaConnectionCard.vue?vue&type=template&id=7881a5f6"
import script from "./lucaConnectionCard.vue?vue&type=script&lang=js"
export * from "./lucaConnectionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__